/* eslint-disable @reatom/unit-naming-rule */

import { type PairModel } from '@root/entities/pair'

import { reatomLimitOrderBuy } from './reatom-limit-order-buy'
import { reatomLimitOrderSell } from './reatom-limit-order-sell'

import type { TradeApi } from '@root/shared/api'

export const reatomLimitOrder = ({
  dto,
  pair,
}: {
  dto: TradeApi.LimitOrderDto
  pair: PairModel
}) => {
  const limitOrder =
    dto.type === 'buy'
      ? reatomLimitOrderBuy({
          dto: dto as TradeApi.LimitOrderBuyDto,
          pair,
        })
      : reatomLimitOrderSell({
          dto: dto as TradeApi.LimitOrderSellDto,
          pair,
        })

  //#region Computed
  const orderAmountAtom = (() => {
    if (limitOrder.type === 'buy') {
      return limitOrder.purchaseAmountBase
    }
    return limitOrder.sellAmountCurrency
  })()

  //#endregion

  return {
    ...limitOrder,
    orderAmount: orderAmountAtom,
  }
}
export type LimitOrderModel = ReturnType<typeof reatomLimitOrder>
